import { Routes, Route, Navigate } from 'react-router-dom';
import { DashboardPage } from './pages/DashboardPage.tsx';
import { RoomPage } from './pages/RoomPage.tsx';
import { DebugRoomPage } from './pages/DebugRoomPage.tsx';
import { ErrorBoundary } from './lib/ErrorBoundary.tsx';

export function App() {
  return (
    <ErrorBoundary>
      <Routes>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/room/:id" element={<RoomPage />} />
        <Route path="/debug/room/:id" element={<DebugRoomPage />} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </ErrorBoundary>
  );
}
